import { ICalendarResource } from './filters';

export enum calendarGroup {
  client = 'client',
  provider = 'provider'
}
export interface IPlannerGroup extends Omit<ICalendarResource, 'id'> {
  id: string;
}
